import { Badge } from "@/components/ui/badge";
import { useTranslation } from "@/features/utils/i18n";
import { isBeta, type ChannelKind } from "./channels";

/** "Bêta", next to the name of a channel that is still being proven; nothing for the others. */
export const BetaBadge = ({ kind }: { kind: ChannelKind }) => {
  const { t } = useTranslation("connectors");
  if (!isBeta(kind)) return null;
  return (
    <Badge variant="secondary" className="px-1.5 py-0 text-[10px] uppercase">
      {t("picker.beta")}
    </Badge>
  );
};
